import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { InctvLedgerLineList } from '@/sc/entities/inctvLedgerLine/InctvLedgerLineList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback } from 'react';

export const InctvLedgerDetail = () => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'distLedgerLine', label: 'Lines', content: <InctvLedgerLineList inctvLedgerObj={entityObj} /> },
  ];

  const pay = () => {
    const req = {
      entity: 'INCTV_LEDGER',
      pluginCode: 'INCTV_LEDGER_PAY_ACTION_PLUGIN',
    };

    const job = {
      name: 'Pay Incentive Ledger',
      module: 'sc',
      entity: 'INCTV_LEDGER',
      entityId: entityObj.id,
      rsrcCode: 'INCTV_LEDGER_PAY_ACTION_PLUGIN',
      reqParamJson: JSON.stringify(req),
      cat: 'ACTION',
    };

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id);
    });
  };

  const augButtons = useCallback(
    (buttons) => {
      if (entityObj.status !== 'PAID') {
        buttons.push(<TitleButton icon={fas.faDollarSign} toolTip="Pay" onClick={pay} />);
      }
    },
    [entityObj.status],
  );

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
